import { useMemo } from "react"
import { findInChildren } from "library/tree/index.mjs"

export function useRegimeSearchMatches(tree, term, limit = 20) {
    return useMemo(findMatches, [tree, term, limit])

    function findMatches() {
        const query = term?.trim().toLowerCase()
        if (!tree || !query) return []
        return findInChildren(tree, isMatch).slice(0, limit)

        function isMatch(node) {
            if (node === tree) return false
            return node.label?.toLowerCase().includes(query) || node.code?.toLowerCase().includes(query)
        }
    }
}
